<template lang="pug">
.themenu(v-show="$route.name != 'planner'" v-shortcuts="[{ shortcut: [ 'f9', ], callback: shortcuts, push: true, focus: true },]")
  modal-shortcuts
  .nav-bar
    .logo-header
      router-link(to='/')
        img.navbar-logo(:src="urlIcon" alt='Logo')
    vm-navbar(class="sub-nabar" color="secondary" text-color="#fff", active-text-color="rgba(163,73,54,1)" type="flat")
      vm-navbar-item(index="0" v-for="(item, i) in menuItems" :key="i")
        vm-tooltip(v-if="includeRole(item.roles)" :text="$t(item.name)")
          router-link(:to='item.link')
            vm-icon(:icon="item.icon" size="1.4rem")
    .bottom-menu
      vm-dropdown(vm-position="right" vm-trigger-click)
      vm-tooltip(text="Salir")
        vm-button.help(type="flat" radius color="secondary" text-color="#fff" active-text-color="rgba(163,73,54,1)" icon="log-in-outline" @click="logout")
  .sub-menu
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const ModalShortcuts = () => import('@/components/aditionals/ModalShortcuts.vue')

export default {
  name: 'TheMenu',
  components: {
    ModalShortcuts
  },
  data: () => ({
    activeItem: 0
  }),
  computed: {
    ...mapGetters([
      'menuItems',
      'urlIcon'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShortcutsVisible'
    ]),
    includeRole (roles) {
      return roles.includes(this.$auth.user().view_permissions[0])
    },
    shortcuts () {
      this.setModalShortcutsVisible(true)
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: 'login' }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.themenu {
  height: 100%;
  display: flex;
  width: 90px;
  background: rgba(var(--secondary),1);
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  .logo-header {
    margin: 10px 0px 0px 0px;
    text-align: center;
  }
  .nav-bar {
    position: relative;
  .sub-nabar{
    width: 90px;
    display: block;
    transform: translateY(-50%);
    top: 40%;
    .vm-navbar--item {
      padding: 5px;
      margin: 0px 6px;
      .router-link-active {
        background-color: #0D0D0D;
        i {
          color: #FFF;
        }
        ~.vm-navbar-after {
            width: 100%;
        }
      }
      span {
        margin-top: 3px;
      }
      a {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 5px;
        padding: 10px 22px;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: background 0.4s linear;
      }
    }
  }
  }
  .bottom-menu {
    position: absolute;
    bottom: 24px;
    width: 5px;
    left: 28%;
    .help {
      cursor: pointer !important;
      pointer-events: inherit;
      .vm-icon {
        font-size: 1.3rem;
      }
    }
  }
  .sub-menu {
    height: 100%;
    background-color: #1d49b6;
    width: 190px;
    position: relative;
  }
}
.heading {
  min-width: 180px;
  padding: 2px 12px;
  h4 {
    padding-top: 3px;
  }
}
.nonotifications {
  text-align: center;
}
.navbar-logo {
  width: 80px;
}
</style>
